import React from 'react';
import { Formik } from "formik";
import * as Yup from 'yup';
const SchemaSorteos = Yup.object({
    numero1: Yup.string().required('El número 1 es requerido').min(3, 'Deben ser 3 números'),
    numero2: Yup.string().when('tipo', {
        is: 1,
        then: Yup.string().required('El número 2 es requerido').min(3, 'Deben ser 3 números')
    }),
});

export default function CerrarSorteo(props) {
    const { Close, Tipo,NumerosG } = props;
    console.log("Tipo",Tipo)
    return (
        <Formik
            /* initialValues={{
                numero1: '',
                numero2: '',
                tipo: Tipo
            }} */
            initialValues={{
                numero1: NumerosG?NumerosG.numero1:'',
                numero2: NumerosG?NumerosG.numero2:'',
                tipo: Tipo
            }}
            validationSchema={SchemaSorteos}
            enableReinitialize="true"
            onSubmit={(values, actions) => {
                console.log("post");
                Close(values, actions);
                //alert("pass");
                //Save(values, actions);
            }}>
            {({
                values,
                errors,
                status,
                setFieldValue,
                handleBlur,
                handleChange,
                handleSubmit,
                resetForm
            }) => <div className="modal" id="SorteoFin" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="exampleModalLabel">Números Ganadores</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <form onSubmit={handleSubmit} >
                                <div className="modal-body">
                                    <div className="row">
                                        <div className={Tipo==0?"col-sm-12 col-md-12 col-lg-12":"col-sm-6 col-md-6 col-lg-6"}>
                                            <div className={errors.numero1 ? "form-group" : "form-group"}>
                                                <label htmlFor="exampleInputEmail1">Número 1:</label>
                                                <input type="text" maxLength={3} onChange={handleChange} value={values.numero1 || ""} className="form-control numeric" name="numero1" id="numero1" autoComplete="none" />
                                                <span className="help-block">{errors.numero1}</span>
                                            </div>
                                        </div>
                                        {Tipo == 1 && (
                                            <div className="col-sm-6 col-md-6 col-lg-6">
                                                <div className={errors.numero2 ? "form-group" : "form-group"}>
                                                    <label htmlFor="exampleInputEmail1">Número 2:</label>
                                                    <input type="text" maxLength={3} onChange={handleChange} value={values.numero2 || ""} className="form-control numeric" name="numero2" id="numero2" autoComplete="none" />
                                                    <span className="help-block">{errors.numero2}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => () => resetForm()} >Cancelar</button>
                                    <button type='submit' className="btn btn-primary">Guardar</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            }
        </Formik>
    )
}
